import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { patentOwnerOptions } from '@/module/Nomen/PatentOwner/model/PatentOwnerModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type PatentOwnerSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function PatentOwnerSelectControl<T extends FieldValues>(props: PatentOwnerSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(patentOwnerOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
